import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingSection() {
  const trending = articles
    .filter((a) => a.isHot)
    .slice(0, 5);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-950">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-400">
              <i className="ri-fire-line" />
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100">今日热点</h2>
          </div>
          <Link
            to="/category/daily-gossip"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors flex items-center gap-1"
          >
            查看更多 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {/* Main featured */}
          <Link
            to={`/article/${trending[0].id}`}
            className="group md:col-span-2 lg:col-span-1 lg:row-span-2 flex flex-col bg-background-900 rounded-xl overflow-hidden border border-background-800/50 hover:border-primary-500/30 transition-all"
          >
            <div className="relative h-48 md:h-64 lg:h-full lg:min-h-[280px] overflow-hidden">
              <img
                src={trending[0].image}
                alt={trending[0].title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/30 to-transparent" />
              <div className="absolute top-3 left-3 flex items-center gap-2">
                {trending[0].isExclusive && (
                  <span className="px-2 py-0.5 rounded bg-primary-500 text-background-50 text-xs font-bold">
                    独家
                  </span>
                )}
                <span className="px-2 py-0.5 rounded bg-accent-500/90 text-background-50 text-xs font-bold">
                  <i className="ri-fire-line mr-0.5" />
                  爆
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="text-xs text-primary-400 font-medium mb-1.5 block">
                  {trending[0].categoryName}
                </span>
                <h3 className="text-base md:text-lg font-bold text-foreground-100 group-hover:text-primary-300 transition-colors line-clamp-2">
                  {trending[0].title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-2 line-clamp-2">
                  {trending[0].summary}
                </p>
              </div>
            </div>
          </Link>

          {/* Side items */}
          {trending.slice(1, 5).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col bg-background-900 rounded-xl overflow-hidden border border-background-800/50 hover:border-primary-500/30 transition-all"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 to-transparent" />
                <div className="absolute top-2 left-2 flex items-center gap-1.5">
                  {article.isExclusive && (
                    <span className="px-1.5 py-0.5 rounded bg-primary-500/90 text-background-50 text-[10px] font-bold">
                      独家
                    </span>
                  )}
                  <span className="px-1.5 py-0.5 rounded bg-accent-500/80 text-background-50 text-[10px] font-bold">
                    热
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4 flex-1 flex flex-col">
                <span className="text-xs text-primary-400 font-medium mb-1">
                  {article.categoryName}
                </span>
                <h3 className="text-sm font-bold text-foreground-200 group-hover:text-primary-300 transition-colors line-clamp-2 flex-1">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-600">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {(article.views / 10000).toFixed(1)}万
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}